<script lang="ts">
	export let direction: "left" | "right" = "left";
	export let hover = false;
	export let fillMode = false;
	export let fill = "";

	$: fillStyle = fill !== "" ? `fill:${fill};` : "";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width={fillMode ? '100%' : '10'}
	height={fillMode ? '100%' : '19.738'}
	viewBox="0 0 10 19.738"
	class:hover
	class:custom-fill={fill !== ''}
	class:right={direction === 'right'}>
	<g>
		<g>
			<path
				style={fillStyle}
				d="M.44 0a.44.44 0 0 0-.316.746l8.824 9.123-8.824 9.123a.44.44 0 0 0 .633.612l9.12-9.429a.44.44 0 0 0 0-.612L.756.134A.441.441 0 0 0 .44 0z"
				transform="rotate(180 5 9.869)" />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&:not(.custom-fill) {
			path {
				fill: #46474b;
			}

			&.hover {
				path {
					fill: var(--default-hover-btn-1);
				}
			}
		}

		&.right {
			transform: rotate(180deg);
		}
	}

</style>
